import React from 'react';

import { ChipsList } from '@/components/ChipsList';
import { Technology } from '@/types';

interface TagsCellProps {
  technology: Technology;
}

/**
 * Memoized cell renderer for tags column
 *
 * Features:
 * - Shows first tag with "+N" counter for additional tags
 * - Hovering anywhere in the cell shows all tags in tooltip
 * - Matches Assets TagsCell pattern
 *
 * @param technology - The technology to render tags for
 */
export const TagsCell: React.FC<TagsCellProps> = React.memo(
  ({ technology }) => {
    const tags = technology.tags || [];

    if (!tags.length) return <>-</>;

    return (
      <ChipsList
        items={tags}
        maxVisible={1}
        variant="filter"
        size="xs"
        data-testid="technology-tags"
        wrapInTooltip
      />
    );
  }
);

TagsCell.displayName = 'TagsCell';
